module.exports = __webpack_public_path__ + "img/marketing-app.1e4e6e0c.svg";